import {ListItem} from "@domain/common/list-view/list-item";

/**
 * DTO d'un référentiel de la gestion des frais
 */
export class Referentiel implements ListItem {
    id: number;
    type: string;
    libelle: string;
    code: string;
    icone: string;
    readOnly: boolean;
    ordre: number;
    defaut: boolean = false;
    codeGroupe: string;
    libelleGroupe: string;
    isGroupeMcc: boolean = false;

    getKey(): number {
        return this.id;
    }
}
